/* global bocAmchart4 */

/**
 * @typedef {{graphs, addTimeSeriesGraph, addGraphsToChart}} bocDataGraphs
 */

/**
 * Set the the list of series and labels from the shortcode and add all the graphs to the chart
 *
 * @returns {bocDataGraphs} object to process graphs
 */
bocAmchart4.DataGraphs = function () {

    this.graphs = [];
    this.reservedSeries = [];
    this.xFieldSeries = [];

    /**
     * Find lowest available graph array index to add the automatic graphs
     * @returns {number} available id
     */
    this.getFirstAvailableIndex = function () {
        var index = 0;
        var availableIndex = -1;
        while (availableIndex !== index) {
            availableIndex = index;
            this.graphs.forEach(function (graph) {
                if (graph.index === index) {
                    index++;
                }
            });
        }
        return availableIndex;
    };

    /**
     * Add the graphs array element
     * @param {string} xAxisType "date", "text" or "number"
     * @param {string} valueField series name as it appears in prepared data
     * @param {string} label label to be used for this graph
     * @returns {void}
     */
    this.addSeriesGraph = function (xAxisType, valueField, label) {
        var index = this.getFirstAvailableIndex();

        if (this.reservedSeries.indexOf(valueField) === -1) {
            var valueFields;

            if (xAxisType === 'number') {
                var xValueField = 'category';
                this.xFieldSeries.forEach(function (xField) {
                    if (xField.index === index) {
                        xValueField = xField.valueField;
                    }
                });
                valueFields = [xValueField, valueField];
            } else {
                valueFields = valueField;
            }

            this.graphs.push({
                'index': index,
                'xAxisType': xAxisType,
                'graphType': null,
                'valueFields': valueFields,
                'label': label
            });
        }
    };

    /**
     * Add the candlestick / floating column with open and close values with specific index based on shortcode
     * @param {string} xAxisType "date", "text" or "number"
     * @param {string} openSeries series name as it appears in prepared data
     * @param {string} closeSeries series name as it appears in prepared data
     * @param {string} label label to be used for this graph
     * @param {int} index graph's index to be used in graphs array
     * @returns {void}
     */
    this.addCandlestickChart = function (
        xAxisType,
        openSeries,
        closeSeries,
        label,
        index
    ) {
        this.reservedSeries.push(openSeries, closeSeries);
        this.graphs.push({
            'index': index,
            'xAxisType': xAxisType,
            'graphType': 'candlestick',
            'valueFields': [openSeries, closeSeries],
            'label': label
        });
    };

    /**
     * Add the series based on shortcode with specific index
     * @param {string} xAxisType "date", "text" or "number"
     * @param {string} valueField series name as it appears in prepared data
     * @param {string} label label to be used for this graph
     * @param {int} index graph's index to be used in graphs array
     * @returns {void}
     */
    this.addManualChart = function (xAxisType, valueField, label, index) {
        if (this.reservedSeries.indexOf(valueField) !== -1) {
            return;
        }
        this.reservedSeries.push(valueField);
        var valueFields;
        if (xAxisType === 'number') {
            var xValueField = 'category';
            this.xFieldSeries.forEach(function (xField) {
                if (xField.index === index) {
                    xValueField = xField.valueField;
                }
            });
            valueFields = [xValueField, valueField];
        } else {
            valueFields = valueField;
        }
        this.graphs.push({
            'index': index,
            'xAxisType': xAxisType,
            'graphType': null,
            'valueFields': valueFields,
            'label': label
        });
    };

    /**
     * Add the series to reserved to be used for calculations
     * @param {string} reservedSeries series name as it appears in prepared data
     * @returns {void}
     */
    this.addReservedSeries = function (reservedSeries) {
        this.reservedSeries.push(reservedSeries);
    };

    /**
     * Add the series to reserved to be used as XField
     * @param {string} reservedSeries series name as it appears in prepared data
     * @param {integer} index value
     * @returns {void}
     */
    this.addXFieldSeries = function (reservedSeries, index) {
        this.reservedSeries.push(reservedSeries);
        this.xFieldSeries.push({
            "index": index,
            "valueField": reservedSeries
        });
    };

    /**
     * Create graphs for the chart based on currently collected graphs array
     * @param {object} chart Amcharts 4 chart object
     * @returns {void}
     */
    this.addGraphsToChart = function (chart) {
        this.graphs.sort(function (first, second) {
            return first.index > second.index ? 1 : -1;
        });
        this.graphs.forEach(function (graph) {
            bocAmchart4.addGraph(
                chart,
                graph.xAxisType,
                graph.graphType,
                graph.valueFields,
                graph.label,
                graph.index
            );
        });
    };
};
